import { useTheme } from '@emotion/react';

const KpiGauge = ({ value }) => {
  const clampedValue = Math.max(4, Math.min(value * 100, 96));
  const theme = useTheme();
  const containerStyle = {
    position: 'relative',
    width: '90%',
    maxWidth: '200px',
    padding: '5px',
    marginLeft: 'auto',
  };

  const barStyle = {
    display: 'flex',
    height: '16px',
    borderRadius: '9999px',
    overflow: 'hidden',
    border: '1px solid #ccc',
    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.1)',
  };

  const segmentStyle = {
    flex: 1,
  };

  const pointerWrapperStyle = {
    position: 'absolute',
    top: '18px',
    left: `${clampedValue}%`,
    transform: 'translateX(-50%)',
    height: 0,
    width: 0,
  };

  const triangleStyle = {
    width: 0,
    height: 0,
    borderLeft: '6px solid transparent',
    borderRight: '6px solid transparent',
    borderBottom: `8px solid ${
      theme.palette.mode === 'dark' ? 'white' : 'black'
    }`,
    transform: 'translateX(-50%)',
  };

  return (
    <div style={containerStyle}>
      <div style={barStyle}>
        <div style={{ ...segmentStyle, backgroundColor: '#2ecc71' }} />
        <div style={{ ...segmentStyle, backgroundColor: '#a2e6b8' }} />
        <div style={{ ...segmentStyle, backgroundColor: '#f1c40f' }} />
        <div style={{ ...segmentStyle, backgroundColor: '#e74c3c' }} />
      </div>
      <div style={pointerWrapperStyle}>
        <div style={triangleStyle} />
      </div>
    </div>
  );
};

export default KpiGauge;
